import React from "react"
import { Outlet } from "react-router"
import Wrapper from "../components/Wrapper"
import Sidebar from "../components/sidebar/Sidebar"
import { Main } from "@components/Main"
import Navbar from "../components/navbar/Navbar"
import Content from "../components/Content"
import Footer from "../components/Footer"
import { getNavItems } from "../components/sidebar/dashboardItems"
import { useAuthUserDetails } from "@apis/users/useUsers"

export const Dashboard = ({ children }: { children: React.ReactNode }) => {
  const { data: userData } = useAuthUserDetails()
  const dashboardItems = getNavItems(userData?.roles || [])

  return (
    <React.Fragment>
      <Wrapper>
        <Sidebar items={dashboardItems} />
        <Main>
          <Navbar />
          <Content>
            {children}
            <Outlet />
          </Content>
          <Footer />
        </Main>
      </Wrapper>
    </React.Fragment>
  )
}
